import { FormGroup } from "@angular/forms";
import { PenaltyFactor } from "../../../models/penalty-factor.model";
import { flag, hours } from "../../form/controls";

export const PENALTY_HOURS = [
    { control: "catATRN", label: "CAT.A TRN" },
    { control: "mtomFHGR6400", label: "MTOM FH > 6400" },
    { control: "mtomFHLDS6400", label: "MTOM LDS > 6400" },
] as const;

/** One form, whether or not the flight has the factor: an empty one logs it. */
export function buildPenaltyFactorGroup(penalty: PenaltyFactor | null) {
    return new FormGroup({
        catATRN: hours(penalty?.catATRN ?? null),
        windGR33: flag(!!penalty?.windGR33),
        windGR45: flag(!!penalty?.windGR45),
        mtomFHGR6400: hours(penalty?.mtomFHGR6400 ?? null),
        mtomFHLDS6400: hours(penalty?.mtomFHLDS6400 ?? null),
    });
}

export type PenaltyFactorGroup = ReturnType<typeof buildPenaltyFactorGroup>;
